// Translations
export const T = {
  en_GB: {
    catalogueValue: "Catalogue value",
    overriddenBy: "Overridden for this advice session",
    note: "Note",
  },
  nb_NO: {
    catalogueValue: "Katalogverdi",
    overriddenBy: "Overstyrt for denne rådgivningen",
    note: "Begrunnelse",
  },
} as const;
